import axios, { post } from "axios"

import { devMode } from "./base"
import { arrayToString, arrayObjToString, stypes } from "../components/common/common"

const baseDomain = `https://m-car${devMode ? "-dev" : ""}.mioto.vn`


const commonDomain = `https://m-b2b${devMode ? "-dev" : ""}.mioto.vn`

export function init() {
    return axios({
        withCredentials: true,
        method: "GET",
        url: `${baseDomain}/init/app`
    })
}

export function searchCarForList(filter) {

	// const instantBooking = filter.instantBooking ? "&instant=true" : "";
	// const directDelivery = (filter.directDelivery || filter.dPrice >= 0) ? "&delivery=true" : "";
	// const minPrice = filter.minPrice > 0 ? `&minPrice=${filter.minPrice * 1000}` : "";
	// const maxPrice = (filter.maxPrice > 0) ? `&maxPrice=${filter.maxPrice * 1000}` : "";
	// var features = "";
	// if (filter.features && filter.features.length > 0) {
	// 		features = `&features=${arrayToString(filter.features)}`;
	// }
	const vType = filter.vehicleType > 0 ? `&vType=${filter.vehicleType}` : "";
	// const vMake = (filter.vehicleMake && filter.vehicleMake !== "" && filter.vehicleMake > 0) ? `&vMake=${filter.vehicleMake}` : "";
	// const vModel = (filter.vehicleModel && filter.vehicleModel !== "" && filter.vehicleModel > 0) ? `&vModel=${filter.vehicleModel}` : "";
	const transmission = filter.transmission > 0 ? `&transmission=${filter.transmission}` : "";

	// const limitKM = filter.limitKM >= 0 ? `&limitKM=${filter.limitKM}` : "";
	// const maxDPrice = filter.dPrice >= 0 ? `&maxDPrice=${filter.dPrice * 1000}` : "";
	// const maxLimitKMPrice = filter.limitKMPrice >= 0 ? `&maxLimitKMPrice=${filter.limitKMPrice * 1000}` : "";
	// const pVerified = filter.pVerified ? `&pVerified=${filter.pVerified}` : "";
	// const fuel = filter.fuel > 0 ? `&fuel=${filter.fuel}` : "";
	// const fuelC = filter.fuelC > 0 ? `&fuelC=${filter.fuelC}` : "";
	// const seatFrom = filter.minSeat > 0 ? `&seatFrom=${filter.minSeat}` : "";
	// const seatTo = filter.maxSeat > 0 ? `&seatTo=${filter.maxSeat}` : "";
	// const yearFrom = filter.minYear > 0 ? `&yearFrom=${filter.minYear}` : "";
	// const yearTo = filter.maxYear > 0 ? `&yearTo=${filter.maxYear}` : "";
	// const radius = filter.radius > 0 ? `&radius=${filter.radius}` : "";
	const fromCarId = (filter.fromCarId && filter.fromCarId !== "") ? `&fromCarId=${filter.fromCarId}` : "";

	// const supportIns = filter.supportIns ? `&supportIns=true` : "";
	// const supportPassport = filter.supportPassport ? `&supportPassport=true` : "";

	// wd
	const wdLocations = (filter.wdLocations && filter.wdLocations !== "") ? `&wdLocations=${encodeURIComponent(filter.wdLocations)}` : "";
	const wdOneWay = stype == stypes.WD ? `&wdOneWay=${filter.wdOneWay}` : "";

	const wdDistanceBackOW = filter.wdOneWay && filter.wdDistanceBackOW >= 0 ? `&wdDistanceBackOW=${filter.wdDistanceBackOW}` : "";
	const wdDistance = filter.wdDistance >= 0 ? `&wdDistance=${filter.wdDistance}` : "";
	const stype = filter.stype ? `&stype=${filter.stype}` : "";

	return axios({
			method: "POST",
			withCredentials: true,
			url: `${commonDomain}/order/search?lat=${filter.lat}&lon=${filter.lng}&st=${filter.startDate.valueOf()}&et=${filter.endDate.valueOf()}&sort=${filter.sort}${vType}${transmission}${fromCarId}&pos=${filter.pos}${wdLocations}${wdOneWay}${wdDistanceBackOW}${wdDistance}${stype}&platformType=${filter.platformType}`
	})
}

export function bookCar(lat, lng, carGroupId, dateFrom, dateTo, platformType, wdDistance, wdLocations, wdOneWay, wdDistanceBackOW, stype, limitKM, info) {


	// self drive
	// const pprice = price ? `&price=${price}` : "";
	// const plimitEnable = limitEnable ? `&limitEnable=${limitEnable}` : "";
	const plimitKM = limitKM ? `&limitKM=${limitKM}` : "";
	// const plimitPrice = limitPrice ? `&limitPrice=${limitPrice}` : "";

	// with driver
	const pwdDistance = wdDistance >= 0 ? `&wdDistance=${wdDistance}` : "";
	const pwdLocations = wdLocations ? `&wdLocations=${encodeURIComponent(wdLocations)}` : "";
	const pwdOneWay = wdOneWay ? `&wdOneWay=${wdOneWay}` : "";
	const pwdDistanceBackOW = wdOneWay && wdDistanceBackOW >= 0 ? `&wdDistanceBackOW=${wdDistanceBackOW}` : "";
	const pstype = stype ? `&stype=${stype}` : "";
	// const pwdPrice = wdPrice ? `&wdPrice=${wdPrice}` : "";

	const f2UserId = info.f2UserId !== "" ? `&f2UserId=${info.f2UserId}` : "";

	const tvlName = info.tvlName ? `&tvlName=${info.tvlName}` : "";
	const tvlPhone = info.tvlPhone ? `&tvlPhone=${info.tvlPhone}` : "";
	const tvlEmail = info.tvlEmail ? `&tvlEmail=${info.tvlEmail}` : "";

	const requiredPapers = info.requiredPapers ? `&papers=${info.requiredPapers}` : "";
	const requiredPapersOther = info.requiredPapersOther ? `&papersOther=${info.requiredPapersOther}` : "";

	const travelerId = info.travelerId ? `&travelerId=${info.travelerId}` : "";
	const miAppId = info.travelerId && info.miAppId ? `&miAppId=${info.miAppId}` : "";
	
	return axios({
		method: "POST",
		withCredentials: true,
		url: `${commonDomain}/order/add?lat=${lat}&lon=${lng}&carGroupId=${carGroupId}&st=${dateFrom}&et=${dateTo}&platformType=${platformType}${pwdDistance}${pwdLocations}${pwdOneWay}${pwdDistanceBackOW}${pstype}${f2UserId}${tvlName}${tvlPhone}${tvlEmail}${requiredPapers}${requiredPapersOther}${plimitKM}${travelerId}${miAppId}`
	})
}

export function getOrderInfo(orderId) {
	return axios({
		method: "GET",
		withCredentials: true,
		url: `${commonDomain}/order/get?orderId=${orderId}`
	})
}

export function getMyOrders(filter, pos, count) {
	const sort = filter.sort > 0 ? `sort=${filter.sort}` : "";
	const status = filter.status > 0 ? `&status=${filter.status}` : "";
	// const carId = filter.carId ? `&carId=${filter.carId}` : "";
	// const stype = filter.stype ? `&stype=${filter.stype}` : "";

	return axios({
			method: "GET",
			withCredentials: true,
			url: `${commonDomain}/order/upcoming?${sort}${status}&pos=${pos}&count=${count}`
	})
}

export function getOrderHistory(filter, pos, count) {
	// const sort = filter.sort > 0 ? `sort=${filter.sort}` : "";?
	const status = filter.status > 0 ? `status=${filter.status}` : "";
	// const carId = filter.carId ? `&carId=${filter.carId}` : "";
	// const stype = filter.stype ? `&stype=${filter.stype}` : "";

	return axios({
			method: "GET",
			withCredentials: true,
			url: `${commonDomain}/order/history?${status}&pos=${pos}&count=${count}`
	})
}

export function getCancelOrderReasons(orderId) {
	return axios({
			method: "GET",
			withCredentials: true,
			url: `${commonDomain}/order/cancel-reason?orderId=${orderId}`
	})
}

export function cancelOrder(bizId, orderId, reason, comment) {
	return axios({
			method: "POST",
			withCredentials: true,
			url: `${commonDomain}/order/cancel?bizId=${bizId}&orderId=${orderId}&reasonId=${reason}&comment=${comment}`
	})
}






// WEBPACK FOOTER //
// ./src/model/car.js